import React from "react";
import { Menu } from "@blueprintjs/core";

export const HtmlMenu = (key: string, attrs: any, children: Object[]) => {
  const items = children.filter((item: any) => item["type"] === "tag");
  const menu_items = items.map((item: any, idx: number) => <Menu.Item key={`${key}-${idx}`} {...item["attribs"]} />);
  return <Menu key={key}>{menu_items}</Menu>;
};
